import { AppLayout } from 'layouts';
import type { GivingContentObjectDetail } from 'models';
import type { ReactNode } from 'react';
import { GivingDetailSkeleton } from '../components';
import { useGivingDetailQuery } from '../queries';

type GivingDetailData = {
  givingContentObject: GivingContentObjectDetail;
};

type P = {
  children: (data: GivingDetailData) => ReactNode;
  header: (data: GivingDetailData) => ReactNode;
  id: string;
};

const GivingDetailLayout = ({ children, header, id }: P) => {
  const { data: givingContentObject, error } = useGivingDetailQuery({ id, options: { throwOnError: false } });

  return (
    <AppLayout error={error}>
      {givingContentObject ? (
        <>
          {header({ givingContentObject })}
          {children({ givingContentObject })}
        </>
      ) : (
        <GivingDetailSkeleton />
      )}
    </AppLayout>
  );
};

export default GivingDetailLayout;
